export default class CustomerType {
    constructor (
        _code = "",
        _name = "",
        _description = "",
        _rate = "", 
        _status = { id: 1, name: 'Activo' }
    ){
        this.code = _code;
        this.name = _name;
        this.description = _description;
        this.rate   = _rate;
        this.status = _status;
    }
}
  